<!--  -->
<style scoped>
    .sidebar {
        z-index: 20000 !important;
    }
</style>

<template>
    <v-navigation-drawer v-model="drawer" absolute temporary class="sidebar">
        <v-list-item to="/">
            <v-list-item-icon>
                <v-img src="../../assets/logo_edf.png" style="width: 100px;"></v-img>
            </v-list-item-icon>
            <v-list-item-title>
                <slot name="sidebar_title"></slot>
            </v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list dense>
            <v-list-item link title="Home" to="/home">
                <v-list-item-icon >
                    <i class="fa fa-home"></i>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>
                        Accueil
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <slot></slot>
        <v-divider></v-divider>
        <v-list dense>
            <v-subheader>...</v-subheader>
        </v-list>
    </v-navigation-drawer>
</template>

<script>

    export default {
        name: 'sidebar',
        components: {},
        props: {
          openTrigger: { type: Number, default: function(){ return null}},
          closeTrigger: { type: Number, default: function(){ return null}}
        },
        created: function(){
        },
        mounted: function(){
        },
        data: function() {
            return {
                drawer: false,
                languagesSheet: false,
                dialogHelp: false
            };
        },
        watch: {
            openTrigger(newVal,oldVal){
                if(newVal && newVal !== oldVal) this.drawer = true
            },
            closeTrigger(newVal,oldVal){
                if(newVal && newVal !== oldVal) this.drawer = false
            }
        },
        methods: {
            changeLanguage(codeLang){
                this.$i18n.i18next.changeLanguage(codeLang);
                this.languagesSheet = false;
                this.$notify({
                    group: 'foo',
                    type: 'success',
                    title: this.$t('Application_notification_language_header'),
                    text: this.$t(codeLang)
                });
            }
        }
    }
</script>

